<template>
  <div class="page-root">
    <div class="app-wrapper">
      <!-- 固定定位的背景图片 -->
      <img src="@/assets/bg_component1.png" class="bg-img bg-left-top" alt="背景1" />
      <img src="@/assets/bg_component2.png" class="bg-img bg-right-top" alt="背景2" />
      <img src="@/assets/bg_component5.png" class="bg-img bg-left-bottom" alt="背景3" />
      <img src="@/assets/bg_component3.png" class="bg-img bg-right-bottom" alt="背景4" />
      <img src="@/assets/bg_component4.png" class="bg-img bg-bottom-center" alt="背景5" />
      <!-- 页面内容层 -->
      <div class="content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from 'vue'
// ---- vue-echarts 6.x + ECharts 5.x ----
import { use } from 'echarts/core'
// 渲染器
import { CanvasRenderer } from 'echarts/renderers'
// 图表类型 (LineChart / PieChart 等)
import { LineChart, PieChart } from 'echarts/charts'
// 组件 (标题、提示、图例等)
import { VisualMapComponent, TitleComponent, TooltipComponent, LegendComponent, GridComponent } from 'echarts/components'

const adjustHtmlHeight = () => {
  const appWrapper = document.querySelector('.app-wrapper');
  const appWrapperHeight = appWrapper.getBoundingClientRect().height;  // 获取app-wrapper的高度
  const newHeight = appWrapperHeight * 1.05;  // 比 app-wrapper 高 5%

  // 获取视口高度
  const viewportHeight = window.innerHeight;

  // 如果计算得到的 newHeight 小于视口高度，则将 newHeight 设置为视口高度
  const finalHeight = newHeight < viewportHeight ? viewportHeight : newHeight;

  // 设置html的高度
  document.documentElement.style.height = `${finalHeight}px`;
};

const adjustScale = () => {
  const baseWidth = 768
  const currentWidth = window.innerWidth

  if (currentWidth <= baseWidth) {
    // 只有当屏幕小于768时才进行缩放
    const scale = currentWidth / baseWidth
    document.body.style.transform = `scale(${scale})`
    document.body.style.transformOrigin = 'top left'
    document.body.style.width = `${100 / scale}%`
  } else {
    // 若宽度大于768，不缩放
    document.body.style.transform = ''
    document.body.style.transformOrigin = ''
    document.body.style.width = ''
  }
}

onMounted(() => {
  adjustScale();

  // 使用 MutationObserver 来监听 app-wrapper 的高度变化
  const appWrapper = document.querySelector('.app-wrapper');
  const observer = new MutationObserver(() => {
    adjustHtmlHeight();  // 当 app-wrapper 的内容发生变化时更新高度
  });
  // 配置 observer 监听元素的子节点变化和样式变化
  observer.observe(appWrapper, {
    attributes: true, // 监听属性变化
    childList: true,  // 监听子节点的变化
    subtree: true     // 监听所有子孙节点的变化
  });

  window.addEventListener('resize', adjustScale);  // 监听窗口大小变化
})

onBeforeUnmount(() => {
  // 清理 MutationObserver 和 resize 事件监听
  const appWrapper = document.querySelector('.app-wrapper');
  if (appWrapper) {
    const observer = new MutationObserver(() => {});
    observer.disconnect();  // 停止监听
  }
  window.removeEventListener('resize', adjustScale);  // 清理事件监听
})

// 使用 use() 显式注册需要的组件
use([
  CanvasRenderer,      // 必须，否则会出现 renderer undefined 的错误
  LineChart,          // 你用到啥图表就注册啥
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  VisualMapComponent
])
</script>

<style>
/* 让页面充满视口，并用 flex 把中间列“顶头居中” */
html, body {
  height: 100%;
}
/* 全局样式、重置等 */
body {
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
  background: url('@/assets/bg.jpg') no-repeat center center;
  background-size: cover;
}

.page-root {
  min-height: 100vh;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: flex-start; /* 贴顶 */
}

/* 关键：最大 768px，宽度自适应，小屏占满宽度 */
.app-wrapper {
  width: 100%;
  max-width: 768px;
  position: relative; /* 建立层叠上下文，方便 content 盖住背景图 */
}

/* 内容层在最上面，避免被 fixed 背景图挡住点击 */
.content {
  position: relative;
  z-index: 1;
}

/* 所有背景图片统一样式 */
.bg-img {
  position: fixed;
  width: 120px; /* 固定宽度 */
  height: auto; /* 高度等比例拉伸 */
  z-index: 0;   /* 放在最底层 */
}

/* 左上 */
.bg-left-top {
  top: 0;
  left: 0;
}

/* 右上 */
.bg-right-top {
  top: 0;
  right: 0;
}

/* 左下 */
.bg-left-bottom {
  bottom: -60px;
  left: 0;
}

/* 右下 */
.bg-right-bottom {
  bottom: -60px;
  right: 0;
}

/* 底部正中 */
.bg-bottom-center {
  bottom: -100px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
